// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__FBcQS","title":"NotFound_title__n1rcL","button":"NotFound_button__lOXhV"};